<template>
    <div class="bento-layout error">
        <!-- Status & Regal Container -->
        <div class="bento-header">
            <div class="bento-status">
                <div class="status-label">Status</div>
                <div class="status-value">Fehler</div>
            </div>
            <div class="bento-slot">
                <div class="slot-label">Regal</div>
                <div class="slot-value">{{ formattedExpectedLocation }}</div>
            </div>
        </div>

        <!-- Preview Container - Shows Error -->
        <div class="bento-preview">
            <div class="preview-content preview-error">
                <v-icon size="48" color="#F44336" class="shake-icon">mdi-alert-circle</v-icon>
                <p>Falsches Regal gescannt!</p>
                <div class="scanned-info">Gescannt: <strong>{{ scannedLocation }}</strong></div>
            </div>
        </div>

        <!-- Message Container -->
        <div class="bento-message">
            <v-icon color="white" size="20">mdi-qrcode-scan</v-icon>
            <span>Scannen Sie: {{ formattedExpectedLocation }}</span>
            <span class="countdown">{{ countdown }}s</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ErrorSlotState',
    props: {
        scannedLocation: {
            type: String,
            required: true
        },
        expectedLocation: {
            type: String,
            required: true
        },
        countdown: {
            type: Number,
            default: 10
        },
        requiresExtraSlot: {
            type: Boolean,
            default: false
        },
        originalSlot: {
            type: String,
            default: ''
        }
    },
    computed: {
        formattedExpectedLocation() {
            const slotName = this.expectedLocation || '';

            // If it's an extra slot starting with SPERRGUT_, format it nicely
            if (slotName.startsWith('SPERRGUT_')) {
                // Remove SPERRGUT_ prefix and convert to title case
                const name = slotName.replace('SPERRGUT_', '');
                // Convert underscores to spaces and capitalize first letter
                return name.replace(/_/g, ' ').toLowerCase()
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ');
            }

            return slotName;
        }
    }
};
</script>

<style scoped>
/* Bento Layout - Responsive Grid */
.bento-layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    min-height: 0;
    overflow: hidden;
    gap: 8px;
    padding: 8px;
    box-sizing: border-box;
    background: #ffffff !important;
}

/* Error Theme */
.bento-layout.error .bento-status,
.bento-layout.error .bento-slot {
    background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%);
}

.bento-layout.error .bento-message {
    background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%);
}

/* Header: Status & Regal */
.bento-header {
    flex-shrink: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    height: auto;
}

.bento-status,
.bento-slot {
    border-radius: 8px;
    padding: 6px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    text-align: center;
}

.status-label,
.slot-label {
    font-size: clamp(8px, 2vw, 10px);
    opacity: 0.9;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.status-value {
    font-size: clamp(12px, 3.5vw, 16px);
    font-weight: bold;
    margin-top: 2px;
}

.slot-value {
    font-size: clamp(14px, 4vw, 20px);
    font-weight: bold;
    margin-top: 2px;
    word-break: break-word;
    line-height: 1;
}

/* Preview Container - Flexible */
.bento-preview {
    flex: 1;
    min-height: 0;
    background: white;
    border-radius: 8px;
    border: 2px solid #e0e0e0;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preview-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px;
    gap: 12px;
}

.preview-error p {
    font-size: clamp(14px, 3.5vw, 18px);
    font-weight: bold;
    color: #f44336;
    margin: 0;
    text-align: center;
}

.scanned-info {
    font-size: clamp(11px, 2.5vw, 14px);
    color: #666;
    text-align: center;
}

.scanned-info strong {
    color: #333;
}

/* Message Container */
.bento-message {
    flex-shrink: 0;
    border-radius: 8px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: white;
    font-size: clamp(11px, 2.8vw, 14px);
    font-weight: 500;
}

.countdown {
    margin-left: auto;
    font-weight: bold;
    font-size: clamp(12px, 3vw, 15px);
}

.shake-icon {
    animation: shake 0.5s;
}

@keyframes shake {
    0%, 100% {
        transform: translateX(0);
    }
    25% {
        transform: translateX(-10px);
    }
    75% {
        transform: translateX(10px);
    }
}

/* Responsive adjustments */
@media (max-width: 480px) {
    .bento-layout {
        gap: 6px;
        padding: 6px;
    }

    .bento-header {
        gap: 6px;
    }

    .bento-status,
    .bento-slot {
        padding: 5px;
    }

    .preview-content {
        padding: 4px;
        gap: 8px;
    }

    .bento-message {
        padding: 6px;
        gap: 6px;
    }
}
</style>
